export class CicadaAPIError extends Error {
  datetime: Date;
  item: string;

  constructor(item: string, mensaje: string) {
    super(mensaje);
    this.name /*:string*/ = "cicada api error"; // Nombre del error personalizado
    this.item /*:string*/ = item; // Nombre del error personalizado
    this.datetime /*Date*/ = new Date(); // Puedes agregar propiedades adicionales según tus necesidades
  }
}

export class CicadaAddInError extends Error {
  item: any;
  datetime: Date;
  constructor(item: string, mensaje: string) {
    super(mensaje);
    this.name /*:string*/ = "cicada add-in error"; // Nombre del error personalizado
    this.item /*:string*/ = item; // Nombre del error personalizado
    this.datetime /*Date*/ = new Date(); // Puedes agregar propiedades adicionales según tus necesidades
  }
}

export class InvalidValueError extends Error {
  item: any;
  datetime: Date;
  constructor(item: string, mensaje: string) {
    super(mensaje);
    this.name /*:string*/ = "invalid value error"; // Nombre del error personalizado
    this.item /*:string*/ = item; // Nombre del error personalizado
    this.datetime /*Date*/ = new Date(); // Puedes agregar propiedades adicionales según tus necesidades
  }
}

export class AuthenticationError extends Error {
  item: any;
  datetime: Date;
  constructor(item: string, mensaje: string) {
    super(mensaje);
    this.name /*:string*/ = "authentication error"; // Nombre del error personalizado
    this.item /*:string*/ = item; // Nombre del error personalizado
    this.datetime /*Date*/ = new Date(); // Puedes agregar propiedades adicionales según tus necesidades
  }
}
